"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuGroupHeaderClassNames: function() {
        return menuGroupHeaderClassNames;
    },
    useMenuGroupHeaderStyles_unstable: function() {
        return useMenuGroupHeaderStyles_unstable;
    }
});
const _react = require("@griffel/react");
const menuGroupHeaderClassNames = {
    root: 'fui-MenuGroupHeader'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Be2twd7: "fy9rknc",
        sj55zd: "f11d4kpn",
        uwmqm3: [
            "fjlbh76",
            "f11qrl6u"
        ],
        z189sj: [
            "f11qrl6u",
            "fjlbh76"
        ],
        Bhrd7zp: "fl43uef",
        Bqenvij: "f1d2rq10",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59"
    }
}, {
    d: [
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".fjlbh76{padding-left:12px;}",
        ".f11qrl6u{padding-right:12px;}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".f1d2rq10{height:32px;}",
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}"
    ]
});
const useMenuGroupHeaderStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuGroupHeaderClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useMenuGroupHeaderStyles.styles.js.map
